import React, { useEffect, useState } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
import TableList from '../../layout/TableList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listLicencesAction, editLicencesAction, deleteLicencesAction } from '../../../actions/licencesActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import { Spinner } from 'react-bootstrap';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { LICENCIAS_ELIMINAR, LICENCIAS_MODIFICAR, PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR } from '../../../data/objects';
import QuickFilter from '../../layout/QuickFilter';
import Paginator from '../../layout/Paginator';
import LicenceSearch from './LicenceSearch';
//Función principal
const LicenceList = props => {
    //Constantes iniciales
    const initialPage = 0;
    const pageSize = 10;
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const authorities = useSelector(state => state.auth.authorities);
    const licencesLoading = useSelector( state => state.licences.loading );
    const licences = useSelector( state => state.licences.licences );
    const isLast = useSelector(state => state.licences.isLast);
    const isFirst = useSelector(state => state.licences.isFirst);
    const total = useSelector(state => state.licences.total);
    const totalPages = useSelector(state => state.licences.totalPages);
    const actualPage = useSelector(state => state.licences.actualPage);
    //Inicializo el state local
    const [ search, setSearch ] = useState('');
    //Parámetros iniciales
    const params = {
        paging: `${initialPage},${pageSize}`,
        sort: 'inicio:desc,fin:desc',
        search
    }
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editLicencesAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteLicencesAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Apellido',
            width: null,
            style: null,
            field: 'operador',
            subfield: 'apellido'
        },
        {
            name: 'Nombre',
            width: null,
            style: null,
            field: 'operador',
            subfield: 'nombre'
        },
        {
            name: 'F. Inicio',
            width: null,
            style: 'text-center',
            field: 'inicio',
            type: 'date'
        },
        {
            name: 'F. Fin',
            width: null,
            style: 'text-center',
            field: 'fin',
            type: 'date'
        },
        {
            name: 'Tipo',
            width: null,
            style: 'text-center',
            field: 'tipo',
            subfield: 'descripcion'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, LICENCIAS_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, LICENCIAS_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Cargo los datos
        loadData(params);
    }, [search]);
    //Manejo la carga de datos
    const loadData = parameters => {
        //Llamo al dispatch
        dispatch( listLicencesAction(parameters) );
    }
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <LicenceSearch
                            setSearch={setSearch}
                        />

                        <hr/>

                        {
                            licencesLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            licences ? (
                                <React.Fragment>
                                    <TableList
                                        prefix="licence"
                                        headers={headers}
                                        items={licences}
                                        state={{
                                            field: 'activo',
                                            disabledClass: 'table-danger',
                                            disabledValue: 0,
                                            hideActions: true
                                        }}
                                    />
                                    <Paginator
                                        actualPage={actualPage}
                                        totalPages={totalPages}
                                        isFirst={isFirst}
                                        isLast={isLast}
                                        pageSize={pageSize}
                                        params={params}
                                        loadData={loadData}
                                    />
                                </React.Fragment>
                                
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LicenceList;